/** Splits "About Exqura" into { rest: "About ", last: "Exqura" } — used by
 * headline fields where the final word is styled as a gold highlight
 * (About Us's "About Exqura", Contact Us's "Contact Us"). Keeping this as
 * one editable "headline" field instead of two separate fields means the
 * admin edits one natural sentence instead of stitching two fragments
 * back together in their head. */
export function splitLastWord(text) {
  const trimmed = (text || "").trim();
  const lastSpace = trimmed.lastIndexOf(" ");
  if (lastSpace === -1) return { rest: "", last: trimmed };
  return { rest: trimmed.slice(0, lastSpace + 1), last: trimmed.slice(lastSpace + 1) };
}

/** Renders that split with the last word gold — the shared look behind
 * both AboutHero and ContactHero's headlines. */
export function HighlightLastWord({ text }) {
  const { rest, last } = splitLastWord(text);
  return (
    <>
      {rest}
      <span className="text-[#D4AF37]">{last}</span>
    </>
  );
}
